// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3_JqJ","icon":"SortAdornment_icon__3ac5A","up":"SortAdornment_up__1BTyI","down":"SortAdornment_down__Zx1DO","active":"SortAdornment_active__2Dl_O"};